// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GNhR","rootMobile":"styles_rootMobile__rM-iu"};